export type CommerceSelection = {
  productId: string
  productName: string
  category: string
  quantity: number
}

export type CommerceBox = {
  price: number
  selections: readonly CommerceSelection[]
}

export type CommerceProduct = {
  id: string
  name: string
  category: string
  quantity: number
}

export type CommerceState = {
  currency: 'NZD'
  value: number
  numItems: number
  products: CommerceProduct[]
}

function aggregateProducts(boxes: readonly CommerceBox[]): CommerceProduct[] {
  const products = new Map<string, CommerceProduct>()

  for (const box of boxes) {
    for (const selection of box.selections) {
      const existing = products.get(selection.productId)
      if (existing) {
        existing.quantity += selection.quantity
        continue
      }

      products.set(selection.productId, {
        id: selection.productId,
        name: selection.productName,
        category: selection.category,
        quantity: selection.quantity,
      })
    }
  }

  return [...products.values()]
}

export function buildCommerceState(
  boxes: readonly CommerceBox[],
  finalValue?: number,
): CommerceState {
  const products = aggregateProducts(boxes)
  const numItems = products.reduce((sum, product) => sum + product.quantity, 0)
  const boxValue = boxes.reduce((sum, box) => sum + box.price, 0)

  return {
    currency: 'NZD',
    value: finalValue ?? boxValue,
    numItems,
    products,
  }
}
